import DOMPurify from "dompurify";

interface TailwindHtmlOptions {
  content: string;
  title?: string;
  includeBodyPadding?: boolean;
}

export const generateTailwindHtmlDoc = ({
  content,
  title = "コンテンツ",
  includeBodyPadding = true
}: TailwindHtmlOptions): string => {
  const sanitizedContent = DOMPurify.sanitize(content, {
    ADD_ATTR: ["class", "style", "id", "href", "src", "alt", "title"],
    ADD_TAGS: ["style"],
    ALLOW_DATA_ATTR: false,
    KEEP_CONTENT: true
  });

  const bodyPadding = includeBodyPadding ? "padding: 20px;" : "padding: 0;";

  return `<!DOCTYPE html>
<html lang="ja">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <script src="https://cdn.tailwindcss.com"></script>
  <style>
    body {
      ${bodyPadding}
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
      line-height: 1.75;
      color: #333;
      font-size: 1rem;
    }
  </style>
</head>
<body>
  <div class="mce-content-body">${sanitizedContent}</div>
</body>
</html>`;
};
